import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const { lang, copy } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts?lang=${lang}`).then((r) => setPosts(r.data)).catch(() => {});
  }, [lang]);

  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid="blog-page">
      <Seo title={copy.seo.blog.title} description={copy.seo.blog.desc} />
      <div className="max-w-6xl mx-auto px-5">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.22em] text-clay font-semibold mb-3">{copy.blog.eyebrow}</p>
          <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight">{copy.blog.title}</h1>
          <p className="mt-4 text-muted max-w-xl">{copy.blog.sub}</p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {posts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link
                to={`/blog/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group flex h-full flex-col rounded-3xl bg-white border border-border overflow-hidden transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl"
              >
                <div className="overflow-hidden">
                  <img src={post.image} alt={post.title} className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <p className="text-[11px] font-mono uppercase tracking-widest text-clay">{post.category} · {post.read_time}</p>
                  <h2 className="mt-2 font-serif font-semibold text-xl text-ink leading-snug group-hover:text-pine transition-colors">{post.title}</h2>
                  <p className="mt-3 text-sm text-muted leading-relaxed flex-1">{post.excerpt}</p>
                  <span className="mt-4 text-sm font-semibold text-clay">{copy.blog.readMore} →</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
